import { NavLink } from 'react-router-dom';

const NetworkAnalystLayout = ({ children }: any) => {
  return (
    <div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card-title">
            <h4>FIND ROLES</h4>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="tabs-header p-0">
            <div className="d-flex tabs">
              <NavLink to="/network-analyst/business">
                <h4 className="m-0">Business</h4>
              </NavLink>
              
              <NavLink to="/network-analyst/individual">
                <h4 className="m-0">Individual</h4>
              </NavLink>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkAnalystLayout;
